import React from 'react';
import OccurrencePhones from "./occurrence-phones.jsx";
import InfoGrid from "../../../../../../components/info-grid/info-grid.jsx";
import projectUtils from "../../../../../../utils/project-utils.js";

const OccurrenceCompanies = ({data}) => {
    const companies = data.companies ?? []

    return (
        <>
            { companies.map((item, index) => {

                const info = [
                    {
                        label: "CNPJ",
                        value: projectUtils.formatCnpjToView(item?.cnpj) ?? "",
                    },
                    {
                        label: "Nome",
                        value: item?.name ?? "",
                    },
                    {
                        subTitle: "Endereço",
                        items: [
                            {
                                label: "Logradouro",
                                value: item?.address?.address ?? "",
                            },
                            {
                                label: "Número",
                                value: item?.address?.number ?? "",
                            },
                            {
                                label: "Bairro",
                                value: item?.address?.neighborhood,
                            },
                            {
                                label: "Complemento",
                                value: item?.address?.complement,
                            },
                            {
                                label: "Município",
                                value: item?.address?.city,
                            },
                            {
                                label: "CEP",
                                value: item?.address?.zipCode,
                            },
                            {
                                label: "Latitude",
                                value: item?.address?.latitude,
                            },
                            {
                                label: "Longitude",
                                value: item?.address?.longitude,
                            }
                        ]
                    }
                ];

                const descriptionInfo = [
                    {
                        subTitle: "Descrição",
                        items: [
                            {
                                label: null,
                                value: item?.information ?? "",
                                valueClassName: 'ml-0!',
                                dots: false,
                                span: 3
                            }
                        ]
                    }
                ]

                return (
                    <>
                        <section className="px-5 space-y-4!">
                            <h2 key={`${index}-0`} className="w-full rounded-[5px] border border-[#e0e0e0] bg-[#efefef] py-0! text-center text-lg! print:text-[19px]! print:break-after-avoid! text-[#4f4f4f]">
                                EMPRESA - {index+1}
                            </h2>

                            <InfoGrid key={`${index}-1`} title={""} items={info} columns={2} labelClassName="text-[#4F4F4F] text-[13px]! print:text-[15px]!" valueClassName={'print:text-[17px]!'} className={'px-0!'} contentClassName={'space-y-1'}/>

                            <OccurrencePhones key={`${index}-2`} data={item} type={'company'}/>

                            { item?.information && (
                                <InfoGrid title={''} items={descriptionInfo} columns={2} labelClassName={'text-[#4F4F4F] text-[13px]! print:text-[15px]'} valueClassName={'print:text-[17px]!'} contentClassName={'space-y-1'} className={'px-0!'}/>
                            )}

                        </section>
                    </>
                )
            })}
        </>
    );
};

export default OccurrenceCompanies;